import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import StatsCard from '../components/StatsCard';
import RecentInvoices from '../components/RecentInvoices';
import RevenueChart from '../components/RevenueChart';

const { FiDollarSign, FiUsers, FiFileText, FiTrendingUp } = FiIcons;

const Dashboard = () => {
  const stats = [
    {
      title: 'Total Revenue',
      value: '$45,280',
      change: '+12.5%',
      icon: FiDollarSign,
      color: 'bg-green-500'
    },
    {
      title: 'Active Clients',
      value: '24',
      change: '+3.2%',
      icon: FiUsers,
      color: 'bg-blue-500'
    },
    {
      title: 'Pending Invoices',
      value: '8',
      change: '-2.1%',
      icon: FiFileText,
      color: 'bg-orange-500'
    },
    {
      title: 'Monthly Growth',
      value: '18.4%',
      change: '+5.7%',
      icon: FiTrendingUp,
      color: 'bg-purple-500'
    }
  ];

  return (
    <div className="space-y-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Dashboard</h1>
        <p className="text-gray-600">Welcome back! Here's what's happening with your agency.</p>
      </motion.div>

      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {stats.map((stat, index) => (
          <motion.div
            key={stat.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
          >
            <StatsCard {...stat} />
          </motion.div>
        ))}
      </div>

      {/* Charts and Recent Activity */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <RevenueChart />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.5 }}
        >
          <RecentInvoices />
        </motion.div>
      </div>
    </div>
  );
};

export default Dashboard;